import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element is not found');
}

if (rootElement.innerHTML) {
  throw new Error('Root element contains some elements');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
